import styled from 'styled-components/macro';
import React from 'react';

import { navigateToStudioCartFor, navigateToShopCart } from 'services/routing';
import { getIsSharedSpace } from 'redux/Studio';
import { SHARED_VIEW_TYPE } from 'utils/constants';

import { Flex } from 'web-ui-kit/legacy';
import PrimaryButton from 'web-ui-kit/buttons/PrimaryButton';

const FeedbackActions = props => {
  const { designId, onClose, onProceedToCheckout, spaceId, isShop } = props;

  const handleClick = () => {
    const navigateToStudioCartArgs = { spaceId, designId };
    const shareMode = getIsSharedSpace();
    if (shareMode) { navigateToStudioCartArgs.viewType = SHARED_VIEW_TYPE; }
    isShop ? navigateToShopCart() : navigateToStudioCartFor(navigateToStudioCartArgs);

    if (onProceedToCheckout) { onProceedToCheckout(); }
    if (onClose) { onClose(); }
  };

  const renderMonarchButton = () => {
    return (
      <PrimaryButton
        id={'checkout'}
        labelText={'Checkout'}
        fluid
        dispatch={(event) => {
          const { type } = event;

          if (type === 'checkout-button-clicked') {
            handleClick();
          }
        }}
      />
    );
  };

  return (
    <ActionFlex justify='space-around' mt={32}>
      {renderMonarchButton()}
    </ActionFlex>
  );
};

export default FeedbackActions;

const ActionFlex = styled(Flex)`
  pointer-events: all !important;
`;
